
import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const UsersContext = createContext({
    users: [],
    totalPages: 1,
    loading: true,
    refresh: () => { }
});

export const useUsersData = () => useContext(UsersContext);

export const UsersProvider = ({ children }) => {
    const [users, setUsers] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(true);

    const loadData = async (page = 1, perPage = 10, filter = '', sort = '-created') => {
        setLoading(true);
        try {
            const res = await pb.collection('users').getList(page, perPage, {
                sort: sort,
                filter: filter || undefined,
            });
            setUsers(res.items || []);
            setTotalPages(res.totalPages || 1);
        } catch (err) {
            console.error("Error loading users data:", err);
            // Don't fail hard
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <UsersContext.Provider value={{ users, totalPages, loading, refresh: loadData }}>
            {children}
        </UsersContext.Provider>
    );
};
